export const SITE_BRAND_TITLE = 'Alfa — Fullstack AI Engineer' as const;

export type StaticPageDefinition = {
  path:
    | '/'
    | '/about'
    | '/services'
    | '/projects'
    | '/blog'
    | '/contact'
    | '/personal-stuff'
    | '/attribution';
  routeClass:
    | 'home'
    | 'about'
    | 'services'
    | 'projects-index'
    | 'writing-index'
    | 'contact'
    | 'personal-stuff'
    | 'attribution';
  title: string;
  description: string;
  openGraph: {
    title: string;
    description: string;
    type: 'website';
  };
  twitter: {
    title: string;
    description: string;
  };
  sitemap: {
    include: true;
    priority: number;
  };
};

export const STATIC_PAGES: readonly StaticPageDefinition[] = [
  {
    path: '/',
    routeClass: 'home',
    title: SITE_BRAND_TITLE,
    description:
      'Fullstack AI Engineer based in Jakarta, targeting Singapore remote (GMT+7). I build scalable backends, full stack products, and AI native systems, from clinic payment platforms to agentic LLM applications.',
    openGraph: {
      title: SITE_BRAND_TITLE,
      description:
        'Fullstack AI Engineer based in Jakarta, targeting Singapore remote (GMT+7). I build scalable backends, full stack products, and AI native systems, from clinic payment platforms to agentic LLM applications.',
      type: 'website',
    },
    twitter: {
      title: SITE_BRAND_TITLE,
      description:
        'Fullstack AI Engineer based in Jakarta, targeting Singapore remote (GMT+7). I build scalable backends, full stack products, and AI native systems, from clinic payment platforms to agentic LLM applications.',
    },
    sitemap: { include: true, priority: 1 },
  },
  {
    path: '/about',
    routeClass: 'about',
    title: 'About',
    description:
      'About Alfa, Fullstack AI Engineer in Jakarta (GMT+7), targeting Singapore remote. 5+ years building scalable backends, full stack products, and AI native systems.',
    openGraph: {
      title: `About — ${SITE_BRAND_TITLE}`,
      description:
        'Fullstack AI Engineer based in Jakarta, targeting Singapore remote. A fast learner and visual thinker who ships payments, microservices, and production AI.',
      type: 'website',
    },
    twitter: {
      title: 'About',
      description:
        'About Alfa, Fullstack AI Engineer in Jakarta (GMT+7), targeting Singapore remote. 5+ years building scalable backends, full stack products, and AI native systems.',
    },
    sitemap: { include: true, priority: 0.8 },
  },
  {
    path: '/services',
    routeClass: 'services',
    title: 'Services',
    description:
      'AI engineering, backend APIs, full stack products, and system analysis, available for Singapore remote full time and for impactful freelance or contract work.',
    openGraph: {
      title: `Services — ${SITE_BRAND_TITLE}`,
      description:
        'Detailed services from a Fullstack AI Engineer based in Jakarta, targeting Singapore remote.',
      type: 'website',
    },
    twitter: {
      title: 'Services',
      description:
        'AI engineering, backend APIs, full stack products, and system analysis, available for Singapore remote full time and for impactful freelance or contract work.',
    },
    sitemap: { include: true, priority: 0.8 },
  },
  {
    path: '/projects',
    routeClass: 'projects-index',
    title: `Projects — ${SITE_BRAND_TITLE}`,
    description:
      'Selected case studies by Alfa: AI native systems, SaaS products, and conversion focused work with measurable outcomes.',
    openGraph: {
      title: `Projects — ${SITE_BRAND_TITLE}`,
      description:
        'Selected case studies spanning AI native systems, SaaS platforms, and digital products.',
      type: 'website',
    },
    twitter: {
      title: `Projects — ${SITE_BRAND_TITLE}`,
      description:
        'Selected case studies by Alfa: AI native systems, SaaS products, and conversion focused work with measurable outcomes.',
    },
    sitemap: { include: true, priority: 0.9 },
  },
  {
    path: '/blog',
    routeClass: 'writing-index',
    title: `Blog — ${SITE_BRAND_TITLE}`,
    description:
      'Engineering deep dives, Singapore remote reflections, and yearly retrospectives from a Fullstack AI Engineer in Jakarta.',
    openGraph: {
      title: `Blog — ${SITE_BRAND_TITLE}`,
      description:
        'Engineering deep dives, Singapore remote reflections, and yearly retrospectives.',
      type: 'website',
    },
    twitter: {
      title: `Blog — ${SITE_BRAND_TITLE}`,
      description:
        'Engineering deep dives, Singapore remote reflections, and yearly retrospectives from a Fullstack AI Engineer in Jakarta.',
    },
    sitemap: { include: true, priority: 0.9 },
  },
  {
    path: '/contact',
    routeClass: 'contact',
    title: 'Contact',
    description:
      'Get in touch with Alfa. Targeting Singapore remote full time. Also open to freelance, part time, and contracts with real impact.',
    openGraph: {
      title: `Contact — ${SITE_BRAND_TITLE}`,
      description:
        'Jakarta · GMT+7 · targeting Singapore remote. Full time preferred; open to impactful freelance and contract work.',
      type: 'website',
    },
    twitter: {
      title: 'Contact',
      description:
        'Get in touch with Alfa. Targeting Singapore remote full time. Also open to freelance, part time, and contracts with real impact.',
    },
    sitemap: { include: true, priority: 0.8 },
  },
  {
    path: '/personal-stuff',
    routeClass: 'personal-stuff',
    title: 'Personal Stuff',
    description:
      'Films, books, favorite stack, snippets, channels, blogs I read, and the gear Alfa uses, with affiliate links where noted.',
    openGraph: {
      title: `Personal Stuff — ${SITE_BRAND_TITLE}`,
      description:
        'Recommendations, taste, tools, and gear from a Fullstack AI Engineer in Jakarta.',
      type: 'website',
    },
    twitter: {
      title: 'Personal Stuff',
      description:
        'Films, books, favorite stack, snippets, channels, blogs I read, and the gear Alfa uses, with affiliate links where noted.',
    },
    sitemap: { include: true, priority: 0.5 },
  },
  {
    path: '/attribution',
    routeClass: 'attribution',
    title: `Attribution | ${SITE_BRAND_TITLE}`,
    description:
      'Fullstack AI Engineer based in Jakarta, targeting Singapore remote (GMT+7). I build scalable backends, full stack products, and AI native systems, from clinic payment platforms to agentic LLM applications.',
    openGraph: {
      title: SITE_BRAND_TITLE,
      description:
        'Fullstack AI Engineer based in Jakarta, targeting Singapore remote (GMT+7). I build scalable backends, full stack products, and AI native systems, from clinic payment platforms to agentic LLM applications.',
      type: 'website',
    },
    twitter: {
      title: SITE_BRAND_TITLE,
      description:
        'Fullstack AI Engineer based in Jakarta, targeting Singapore remote (GMT+7). I build scalable backends, full stack products, and AI native systems, from clinic payment platforms to agentic LLM applications.',
    },
    sitemap: { include: true, priority: 0.4 },
  },
] as const;
